import React from "react";
import mainLogo from "../images/Main.png";
import { Link } from "react-router-dom";

function Footer() {
  const sessionCrystalCategories = sessionStorage.getItem("crystalCategories") ? JSON.parse(sessionStorage.getItem("crystalCategories")) : [];
  const sessionBotanicalCategories = sessionStorage.getItem("botanicalCategories") ? JSON.parse(sessionStorage.getItem("botanicalCategories")) : [];

  return <footer>
    <div className="about-footer">
      <img src={mainLogo}></img>
      <h3>About</h3>
      <p><b>Who we are.</b> We are a small business based off Texas. Learn more about us <a href="#">here.</a></p>
      <p>Secure online payment.</p>
    </div>
    <div className="left-footer">
      <h3>Quick Links</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        {/* <li><a href="#">Guide</a></li> */}
        <li><Link to="/faq">FAQ</Link></li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/categories">Shop by</Link></li>
        <li><Link to="/log-in">Sign In / Account</Link></li>
        <li><Link to="/cart">Cart</Link></li>
        <li><Link to="/terms-of-service">Terms of Service</Link></li>
        <li><Link to="/privacy-policy">Privacy Policy</Link></li>

      </ul>
    </div>
    <div className="middle-footer">
      <h3>Shop Now</h3>
      <ul>
      <li><Link to="/all">All</Link></li>
        <li><Link to="/crystals">Crystals</Link>
          <ul className="footer-subcategories">
            {sessionCrystalCategories.map(cat => <li><Link to={`/all?category=${encodeURIComponent(cat)}`}>{cat}</Link></li>)}
          </ul>
        </li>
        <li><Link to="/botanicals">Botanicals</Link>
        <ul className="footer-subcategories">
            {sessionBotanicalCategories.map(cat => <li><Link to={`/all?category=${encodeURIComponent(cat)}`}>{cat}</Link></li>)}
          </ul>
        </li>
      </ul>
    </div>
    <div className="end-footer">
      <h3>Contact Us</h3>
      <ul>
        <li><i className="bi bi-envelope"></i> <a href="mailto:info@castillobc.shop">info@castillobc.shop</a></li>
        <li><i className="bi bi-phone"></i><a href="tel:8558622324">855-862-2324</a></li>
        <li><i className="bi bi-facebook"></i><Link to="https://www.facebook.com/profile.php?id=61585253246452#">Castillo Botanicals & Crystals</Link></li>
        <li><i className="bi bi-instagram"></i><Link to="https://www.instagram.com/castillobcshop/">castillobcshop</Link></li>


      </ul>
    </div>
    <span id="copyrightNotes">Copyright &copy; 2026 Castillo Botanicals & Crystals. All rights reserved.</span>
  </footer>
}

export default Footer;